import React from "react";
import { useParams } from "react-router-dom";
import Orders from "./index.js";
import { CHEFS_FARM, GROWY } from "../../../../constants/CompanyConstants";

const OrdersWrapper = () => {
  const { companyType } = useParams();

  const getCompanyConfig = (type) => {
    switch (type) {
      case "chefs-farm":
        return {
          companyFilter: CHEFS_FARM,
          title: "chefs_farm_orders",
        };
      case "growy":
        return {
          companyFilter: GROWY,
          title: "growy_orders",
        };
      default:
        return {
          companyFilter: "All",
          title: "all_orders",
        };
    }
  };

  const config = getCompanyConfig(companyType);

  return <Orders {...config} />;
};

export default OrdersWrapper;
